import apiBase from "../../api";
import { FETCH_MYWASH_PROMO_WASH } from "../../urls";

// The logged-in user's own wash (name, color, logo/photo as data: URIs),
// already resolved and filtered server-side - see mywashPromoState.js for
// how MyWashPromoV2 uses this. Never throws: any failure (network, auth,
// 5xx) resolves to null, same as "no personalization", so the ad still
// shows the neutral "Vaša perionica" version.
class MywashPromoService {
  fetchMyWash = async () => {
    try {
      const response = await apiBase.get(FETCH_MYWASH_PROMO_WASH);
      if (response.status !== 200) return null;
      return response.data?.data?.wash ?? null;
    } catch {
      return null;
    }
  };
}

export default new MywashPromoService();
